/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const DEFAULT_APP_CONFIG = {
    db: {
        boilerplate: {
            name: 'boilerplate.realm',
        },
    },
    servers: {
        graphql: [
            {
                name: 'graphql-gateway',
                url: 'https://staging-gate.trag-vlinder.io/org-core/',
            },
        ],
        rest: {
            dummyRestServer: {
                baseURL: 'http://10.0.1.13:8000',
            },
        },
        verifierHttp: {
            httpHost: "https://distillers.trag-vlinder.io/api/kgws/v1/verify/",
            verifyEP: "",
            credentialEP: "",
            provenanceEP: "provenance/v1/amrut/",
            apiEP: "api/credential/status/service/v1/",
            timeout: 10000
          }
    },
};
